import { Reducer } from 'redux';

import { SessionLoadCurrentUserAction } from '../../../domains/sessionLoadCurrentUser/actions.types';

import { CurrentNetwork } from './types';

export type SessionAction = SessionLoadCurrentUserAction;

const initialState: CurrentNetwork = {
  id: '',
  permalink: '',
  isLegacyExternalNetwork: false,
  isOfficeTopicsEnabled: false,
  isNativeModeSharePointOnlyFileStorage: false,
  isTranslationEnabled: false,
  isWebPushNotificationsEnabled: false,
  isForcedNotificationEnabled: false,
  isDirectMessagesEnabled: false,
  isDraftPostsEnabled: false,
};

const reducer: Reducer<CurrentNetwork, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.LOAD_CURRENT_USER_FULFILLED': {
      const {
        entities: { networks, users },
        id,
      } = action.payload;
      const networkId = users[id].networkId;
      const {
        permalink,
        isLegacyExternalNetwork,
        isOfficeTopicsEnabled,
        isTranslationEnabled,
        isNativeModeSharePointOnlyFileStorage,
        isWebPushNotificationsEnabled,
        isForcedNotificationEnabled,
        isDirectMessagesEnabled,
        isDraftPostsEnabled,
        networkTopicsState,
      } = networks[networkId];

      return {
        id: networkId,
        permalink,
        isLegacyExternalNetwork,
        isOfficeTopicsEnabled,
        isTranslationEnabled,
        isNativeModeSharePointOnlyFileStorage,
        isWebPushNotificationsEnabled,
        isForcedNotificationEnabled,
        isDirectMessagesEnabled,
        isDraftPostsEnabled,
        networkTopicsState,
      };
    }
    default:
      return state;
  }
};

export default reducer;
